// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a731ec05","455":"e9830329"}[chunkId] + ".chunk.js";
};